exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2S9ZN4KmuyREDN_6JEl8e7{position:absolute;z-index:-1;opacity:1}html[dir=ltr] ._2S9ZN4KmuyREDN_6JEl8e7,html[dir=rtl] ._2S9ZN4KmuyREDN_6JEl8e7{left:0;right:0}html[dir] ._3rP3xa94EJAL9izlTEiwZj{background-color:var(--neutralQuaternaryAlt)}html[dir] ._36GB_IyHmpbU2ro-a6v4Nu{background-color:var(--neutralLighterAlt)}", ""]);
// Exports
exports.locals = {
	"nonWorkingTime": "_2S9ZN4KmuyREDN_6JEl8e7",
	"nonWorkingTimeDark": "_3rP3xa94EJAL9izlTEiwZj",
	"nonWorkingTimeLight": "_36GB_IyHmpbU2ro-a6v4Nu"
};